export default __webpack_public_path__ + "static/media/bg3.772f9423.jpg";